import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { BroadcastService } from '../../services/broadcast/BroadcastService';
import { BroadcastStateService } from '../../services/broadcaststate/BroadcastStateService';
import { formBroadcastUrl } from '../../utils/url';
import { CopyUrlButton, ShareButtons, ShareUrlButton } from '../ShareButtons';
import { LogoLink } from '../shared/LogoLink';
import { StatusContainer } from '../views/View';
import { RecordingStatusIndicator } from './helpers/RecordingStatusIndicator';
export function BroadcasterHeader(props) {
    const { controls } = props;
    const activeBroadcast = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const broadcastOutputBroadcasting = BroadcastService.getOutput().useBroadcasting();
    const broadcastUrl = formBroadcastUrl(activeBroadcast);
    return (_jsxs(BroadcasterHeaderRoot, { children: [_jsxs(StatusContainer, { children: [_jsx(LogoLink, { label: "" }), broadcastOutputBroadcasting && (_jsx(IndicatorsRow, { children: _jsx(RecordingStatusIndicator, { broadcast: activeBroadcast }) }))] }), _jsx(ShareButtons, { children: controls ?? (_jsxs(_Fragment, { children: [_jsx(CopyUrlButton, { url: broadcastUrl }), _jsx(ShareUrlButton, { url: broadcastUrl })] })) })] }));
}
const BroadcasterHeaderRoot = styled.div `
    --tv-LogoLink-height: 2.75rem;

    display: grid;
    grid-template-columns: 1fr auto;
    padding: 0.75rem 1.5rem;

    ${StatusContainer} {
        display: flex;
        align-items: center;
        gap: 1rem;
    }
`;
const IndicatorsRow = styled.div `
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;
